<template>
    <div class="flex flex-col gap-6">
        <h2 class="text-2xl md:text-4xl font-semibold">Patient Case Review</h2>

        <div>
            <h3 class="text-base md:text-2xl font-semibold  mb-3">
                Symptoms of PH1 experienced by patient
            </h3>

            <ul class="list-disc pl-4   font-light">
                <li>
                    At presentation, the patient had bilateral kidney stones and a GFR of 3 mL/min/1.73 m2
                </li>
                <li>
                    The patient had a urinary oxalate level within the acceptable range but had a mildly increased in glycolate
                </li>
                <li>In combination with the other suggestive symptoms and family history, additional investigations were conducted, and the patient was diagnosed with PH1 (confirmed with genetic testing)</li>
            </ul>
        </div>

        <div>
            <h3 class="text-base md:text-2xl font-semibold  mb-3">
                Journey to diagnosis
            </h3>

            <ul class="list-disc pl-4  font-light">
                <li>
                    No diagnosis was received at initial presentation; diagnosis did not occur until severe symptoms prompted wider testing, which identified PH1
                </li>
                <li>
                    The patient initially presented with UTI symptoms and passing of kidney stones, but further investigations were not performed until she presented with uremic symptoms
                    <ul class="list-inside list-['-_'] pl-4">
                        <li>
                            No urine cultures, blood investigations, or kidney stone analyses were completed
                        </li>
                    </ul>
                </li>
                <li>
                    The patient also had family history of kidney issues identified at presentation
                    <ul class="list-inside list-['-_'] pl-4">
                        <li>
                            The patient's elder sister passed away aged 9 years due to kidney failure
                        </li>
                        <li>
                            Multiple family members had a history of kidney stones
                        </li>
                    </ul>
                </li>
            </ul>
        </div>

        <h3 class="text-base md:text-2xl font-semibold  mb-3 p-6 bg-lightblue50 text-center">
            This case displays several missed opportunities for PH1 diagnosis and highlights the importance of PH1 suspicion and testing when patients, particularly pediatric patients, present with kidney stones and with a family history of kidney issues
        </h3>
    </div>
</template>
